import { Model } from 'dva';
import { routerRedux } from 'dva/router';
import pathToRegexp from 'path-to-regexp';
import { delay } from 'redux-saga';
import { acsFetch } from '@mos-utils/acs-fetch';

import { shouldHaveIdentification } from '../helpers/dateHelpers';
import { SEX } from '../components/shared/PersonGender/PersonGender';
import { DEFAULT_FETCH_OPTIONS } from './auth';
import {
  sendCMABusinessError,
  sendCMAFormStart,
  sendCMATechError,
} from '../helpers/CMAstats';

export const ELK = 'elk';

const fetchBlocks = () => {
  const blocks = [
    'snils',
    'passport_rf',
    'person',
    'children',
    'registration_data',
    'relatives',
  ];
  return acsFetch(
    `/api/my/v1/blocks?${blocks.map((block) => `names[]=${block}`).join('&')}`,
    DEFAULT_FETCH_OPTIONS
  );
};

const elkModel: Model = {
  namespace: ELK,
  state: {
    passport_rf: {},
    children: [],
    relatives: [],
  },
  reducers: {
    'getBlocks/finish'(state, { payload }) {
      return payload; // Кэшируем данные на случай, если понадобится восстановить
    },
  },
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname }) => {
        // Если пользователь сам пришёл на страницу ошибки, а не был перенаправлен, то мы открываем ему главную
        const isErrorPage = pathToRegexp('/error').exec(pathname);
        if (isErrorPage && !history.location.state) {
          return dispatch({
            type: 'redirectToMainPage',
          });
        }
      });
    },
  },
  effects: {
    *getBlocks(_, { put, call, select }) {
      try {
        yield delay(0); //hack to have no `Failed to fetch` error when redirect to new
        const { data } = yield call(fetchBlocks);
        const { status } = yield select((state) => state.auth);
        const {
          snils: { snils_number: snilsNumber },
          person: { birthdate },
        } = data;

        const applicantYoungerThan14 = !shouldHaveIdentification(birthdate);
        const getErrorId = (
          applicantYoungerThan14: boolean,
          snilsNumber: string
        ) => {
          if (!snilsNumber) return 'noSnils';
          if (applicantYoungerThan14) return 'youngerThan14';
          return false;
        };

        const errorId = getErrorId(applicantYoungerThan14, snilsNumber);

        if (errorId) {
          sendCMABusinessError('start');
          yield put(
            routerRedux.push({
              pathname: '/error/',
              state: {
                status: 'error',
                statusName: errorId,
              },
            })
          );
          return;
        }
        sendCMAFormStart();

        const blocksDataWithStatus = {
          ...data,
          status,
        };

        yield put({ type: 'getBlocks/finish', payload: blocksDataWithStatus });
        yield put({ type: 'form/getDraft' });
      } catch (error) {
        sendCMATechError('start');
        yield put(
          routerRedux.push({
            pathname: '/error/',
            state: {
              status: 'error',
              statusName: 'serviceNotAvailable',
            },
          })
        );
      }
    },
    *redirectToMainPage({ payload }, { put }) {
      yield put(routerRedux.push('/'));
    },
  },
};

export default elkModel;

export interface ELKChild {
  item_id: string;
  name: string;
  surname: string;
  patronymic: string | null;
  gender: SEX;
  snils_number: string | null;
  birthdate: string | null;
  birth_place: string | null;
  birth_certificate_number: string | null;
  birth_certificate_issued_at: string | null;
  birth_certificate_issued_by: string | null;
  birth_certificate_verified_at: string | null;
  is_birth_certificate_verified: boolean;
  foreign_birth_certificate_number: string | null;
}

export interface Relative extends ELKChild {
  last_name: string;
  first_name: string;
  middle_name: string;
  type: string;
  oms_number: string;
  verified_at: string | null;
  is_verified: boolean;
  driver_license_number: string | null;
  driver_license_issued_at: string | null;
  passport_number: string | null;
  passport_issued_at: string | null;
  passport_issued_by: string | null;
  passport_division_code: string | null;
}

export interface ELKDocument {
  number: string | null;
  issued_by: string | null;
  issued_on: string | null;
  division_code: string | null;
  birth_place: string | null;
}

export interface Elk {
  children: ELKChild[];
  relatives: Relative[];
  passport_rf: ELKDocument;
}
